module.exports = new __parcel__URL__("partner_3.ac09c302.png").toString();